import React from 'react';
import PrintTemplate from 'react-print';
import dateFormat from 'dateformat';
import ReceiptList from './ReceiptList';
import Loader from '../../../../common/elements/Loader';
import jsPDF from 'jspdf';
import { currency } from './../../../../../helpers/';
import logo from './logo-64encoded';
import { siteOfOriginHelper } from '../../../../../../client/helpers/genericHelpers';
import { htmlCompanyDetails } from '../../../../../../client/helpers/addressHelpers';

const siteOfOrigin = siteOfOriginHelper();
var businessAddress = htmlCompanyDetails(siteOfOrigin);

class ReceiptPrintTemplate extends React.Component {

    print = () => window.print()

    download = () => {

        const isGB = (this.props.currency && this.props.currency.common_country_id === 77) || (!this.props.currency && siteOfOriginHelper() === 'gb');
        const abbr = isGB ? 'gb' : 'us';

        let pdf = new jsPDF();
        pdf.addImage( logo, 'PNG', 8, 15 );
        pdf.setFont( 'helvetica' );
        pdf.setFontSize( 12 );
        pdf.setFontType( 'bold' )
        pdf.text( 20, 40, isGB ? `${ currency.taxType() } RECEIPT` : "RECEIPT" );
        pdf.setFontType( 'normal' )
        pdf.text( 20, 46, `Membership Start Date: ${ dateFormat(this.props.receipt.created_at, 'dd mmmm yyyy') }` )
        pdf.text( 20, 52, `Company: ${ this.props.details.values.company ? this.props.details.values.company : '-' }` )
        isGB && pdf.text( 20, 58, `${ currency.taxType() } Number: ${ this.props.details.values.vat ? this.props.details.values.vat : '-' }` )
        pdf.text( 20, 64, `Company Number: ${ this.props.details.values.company_number ? this.props.details.values.company_number : '-' }` )
        pdf.text( 20, 70, `FAO: ${ this.props.details.values.full_name }` )
        pdf.text( 20, 76, `Email Address: ${ this.props.details.values.email_address }` )
        pdf.text( 20, 82, `Phone Number: ${ this.props.details.values.phone }` )

        const vat = Math.round((this.props.receipt.basket.price * 0.2) * 100) / 100;
        const total = Math.round((this.props.receipt.basket.price + vat) * 100) / 100;

        pdf.setFontSize(15);
        let lineNumber = 91;
        this.props.receipt.basket.transaction_items.forEach( item => {
            item.product !== null ? pdf.text( 20, lineNumber + 8, `Product: ${ item.product.name }` ) : null;
            item.package !== null ? pdf.text( 20, lineNumber + 8, `Membership: ${ item.package.name }` ) : null;
            lineNumber += 8;
        });

        pdf.text( 20, lineNumber + 8, `Net: ${ currency.convert( this.props.receipt.basket.price, abbr ) }` );
        isGB && pdf.text( 20, lineNumber + 16, `${ currency.taxType() }: ${ currency.convert( vat, abbr ) }` );
        pdf.setFontType( 'bold' );
        pdf.text( 20, lineNumber + 24, `Total: ${ currency.convert( total, abbr ) }` );
        pdf.setFontType( 'normal' );

		pdf.setFontSize(10);

        pdf.text( 20, lineNumber + 40, `${this.props.company[0].text}` );
	

        pdf.save( `InTouchNetworks-receipt-${ this.props.receipt.id }.pdf` );
    };

    textContent(){
        return (
            <div>
                <h1 className="h1 text-center">{ `${ currency.taxType() } Receipt` }</h1>
                <div className="row">
                    <p className="p-tag col-xs-12 padding-dble-left">
                        <strong>Membership Start Date: </strong>{dateFormat(this.props.receipt.created_at, 'dd mmmm yyyy')}
                    </p>
                </div>
                <div className="row">
                    <p className="p-tag col-xs-12 padding-dble-left"><strong>Company: </strong>{this.props.details.values.company ? this.props.details.values.company : '-'}
                    </p>
                </div>
                <div className="row">
                    <p className="p-tag col-xs-12 padding-dble-left"><strong>{ `${ currency.taxType() } Number: ` }</strong>{this.props.details.values.vat ? this.props.details.values.vat : '-'}
                    </p>
                </div>
                <div className="row">
                    <p className="p-tag col-xs-12 padding-dble-left"><strong>Company
                                    Number: </strong>{this.props.details.values.company_number ? this.props.details.values.company_number : '-'}</p>
                </div>
                <div className="row">
                    <div className="col-xs-12 padding-dble-left">
                        <p className="p-tag"><strong>FAO: </strong>{this.props.details.values.full_name}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 padding-dble-left">
                        <p className="p-tag"><strong>Email Address: </strong>{this.props.details.values.email_address}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 padding-dble-left">
                        <p className="p-tag"><strong>Phone Number: </strong>{this.props.details.values.phone}</p>
                    </div>
                </div>
                <hr />
                <div className="text-center">
                    <ReceiptList receipt={this.props.receipt} />
                </div>
                <hr />
                <div className="row">
                    <div className="col-xs-12">
                       {businessAddress}
                    </div>
                </div>
            </div>
        );
    }

    contentPrint(){
        return (
            <div className="page-width">
                <img className="center-block padding-y"
                    src="https://media.intouchnetworks.com/images/cd5a296d16b664bb1cdd62e42eb9d51d59b5d274_in-touch-logo-on-light.png"
                    alt="In Touch Networks Logo" height="90px"
                />
                { this.textContent.call( this ) }
            </div>
        );
    }

    render() {
        if (!this.props.details || !this.props.receipt) return <Loader network={ this.props.network } />;

        return (
            <div>
                <div id="print-mount">
                    <PrintTemplate>
                        { this.contentPrint.call( this ) }
                    </PrintTemplate>
                </div>
                <button type="button" className="btn btn-primary pull-right margin-right" onClick={() => this.print()}
                    value="Print">
                    <span className="label">Print</span>
                    <span className="icon"><i className="fa fa-angle-right animated-right" /></span>
                </button>
                <button type="button" className="btn btn-primary pull-right margin-right margin-left" onClick={() => this.download()}
                    value="Donwnload">
                    <span className="label">Download PDF</span>
                    <span className="icon"><i className="fa fa-angle-right animated-right" /></span>
                </button>
            </div>
        )
    }
}

export default ReceiptPrintTemplate;


// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/ReceiptPrintTemplate.js